// src/components/common/LoadingSpinner.tsx
import React from 'react';

const LoadingSpinner: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={`flex items-center justify-center h-screen ${className}`}>
      <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
    </div>
  );
};

export default LoadingSpinner;
